var exports = {
  "k": "x28a7bf27--fcf851--container",
};

module.exports = exports;
